export const extensionMarkup = {
  error: `
  <style>
    .error-container {
        text-align: center;
        max-width: 300px;
        margin: 0 auto;
        padding: 20px 15px;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        color: #333;
    }

    .error-icon {
        font-size: 2rem;
        margin-bottom: 0.5rem;
    }

    .error-container h1 {
        font-size: 1.2rem;
        margin-bottom: 0.3rem;
        color: #495057;
        font-weight: 500;
    }

    .error-container p {
        font-size: 0.9rem;
        color: #6c757d;
        line-height: 1.4;
    }
</style>

<div class="error-container">
    <div class="error-icon">⚠️</div>
    <h1>Something went wrong</h1>
    <p>We're experiencing some technical difficulties. Please try again later.</p>
</div>
`,
}
